"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FetchAdapter = void 0;
const querystring_1 = __importDefault(require("querystring"));
class FetchAdapter {
    constructor(options) {
        this.options = {};
        this.options = options;
    }
    async request(method, path, body, query, options) {
        const mergeOptions = { ...this.options, ...options };
        const queryString = query
            ? '?' + querystring_1.default.stringify(query)
            : '';
        try {
            const response = await fetch(`${mergeOptions.baseURL || ''}${path}${queryString}`, {
                method,
                body: body ? JSON.stringify(body) : null,
                ...mergeOptions,
            });
            return {
                status: response.status,
                statusText: response.statusText,
                data: await response.json(),
                headers: [...response.headers.entries()].reduce((acc, [k, v]) => {
                    acc[k] = v;
                    return acc;
                }, {}),
            };
        }
        catch (err) {
            err.isOpenApiError = true;
            throw err;
        }
    }
    withOptions(options) {
        return new FetchAdapter(options);
    }
}
exports.FetchAdapter = FetchAdapter;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQ0EsOERBQXFEO0FBTXJELE1BQWEsWUFBWTtJQUd4QixZQUFZLE9BQXFCO1FBRnpCLFlBQU8sR0FBaUIsRUFBRSxDQUFBO1FBR2pDLElBQUksQ0FBQyxPQUFPLEdBQUcsT0FBTyxDQUFBO0lBQ3ZCLENBQUM7SUFFRCxLQUFLLENBQUMsT0FBTyxDQUFjLE1BQWMsRUFBRSxJQUFZLEVBQUUsSUFBYSxFQUFFLEtBQTBCLEVBQUUsT0FBcUI7UUFDeEgsTUFBTSxZQUFZLEdBQUcsRUFBRSxHQUFHLElBQUksQ0FBQyxPQUFPLEVBQUUsR0FBRyxPQUFPLEVBQUUsQ0FBQTtRQUNwRCxNQUFNLFdBQVcsR0FBRyxLQUFLO1lBQ3hCLENBQUMsQ0FBQyxHQUFHLEdBQUcscUJBQUUsQ0FBQyxTQUFTLENBQUMsS0FBSyxDQUFDO1lBQzNCLENBQUMsQ0FBQyxFQUFFLENBQUE7UUFFTCxJQUFJO1lBQ0gsTUFBTSxRQUFRLEdBQUcsTUFBTSxLQUFLLENBQUMsR0FBRyxZQUFZLENBQUMsT0FBTyxJQUFJLEVBQUUsR0FBRyxJQUFJLEdBQUcsV0FBVyxFQUFFLEVBQUU7Z0JBQ2xGLE1BQU07Z0JBQ04sSUFBSSxFQUFFLElBQUksQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFDLFNBQVMsQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLENBQUMsSUFBSTtnQkFDeEMsR0FBRyxZQUFZO2FBQ2YsQ0FBQyxDQUFBO1lBQ0YsT0FBTztnQkFDTixNQUFNLEVBQUUsUUFBUSxDQUFDLE1BQU07Z0JBQ3ZCLFVBQVUsRUFBRSxRQUFRLENBQUMsVUFBVTtnQkFDL0IsSUFBSSxFQUFFLE1BQU0sUUFBUSxDQUFDLElBQUksRUFBTztnQkFDaEMsT0FBTyxFQUFFLENBQUUsR0FBRyxRQUFRLENBQUMsT0FBTyxDQUFDLE9BQU8sRUFBRSxDQUFFLENBQUMsTUFBTSxDQUFDLENBQUMsR0FBRyxFQUFFLENBQUMsQ0FBQyxFQUFFLENBQUMsQ0FBQyxFQUFFLEVBQUU7b0JBQ2pFLEdBQUcsQ0FBQyxDQUFDLENBQUMsR0FBRyxDQUFDLENBQUE7b0JBQ1YsT0FBTyxHQUFHLENBQUE7Z0JBQ1gsQ0FBQyxFQUFFLEVBQTRCLENBQUM7YUFDaEMsQ0FBQTtTQUNEO1FBQUMsT0FBTyxHQUFHLEVBQUU7WUFDWixHQUF5QixDQUFDLGNBQWMsR0FBRyxJQUFJLENBQUE7WUFDaEQsTUFBTSxHQUFHLENBQUE7U0FDVDtJQUNGLENBQUM7SUFFRCxXQUFXLENBQUMsT0FBcUI7UUFDaEMsT0FBTyxJQUFJLFlBQVksQ0FBQyxPQUFPLENBQUMsQ0FBQTtJQUNqQyxDQUFDO0NBQ0Q7QUFyQ0Qsb0NBcUNDIn0=